module.exports = __webpack_public_path__ + "img/freight_yard3_2.bb5357cf.png";